export enum DateFrame {
    TODAY = 'TODAY',
    YESTERDAY = 'YESTERDAY',
    '7DAYS' = '7DAYS',
    MONTH = 'MONTH',
    LAST_MONTH = 'LAST_MONTH',
    LAST_3MONTHS = 'LAST_3MONTHS',
    LAST_6MONTHS = 'LAST_6MONTHS',
    YEAR = 'YEAR',
    CUSTOM = 'CUSTOM',
}

export type TimeFrame = {
    startDate?: Date;
    endDate?: Date;
    frame: {
        timeEnum: DateFrame;
        timeLabel: string;
    };
};

export enum TimePickerType {
    SHORT = 0,
    LONG = 1,
}

export type TimePickerProps = {
    timeFrame: TimeFrame;
    setTimeFrame: (frame: TimeFrame) => void;
    timePickerType: TimePickerType;
    callback: (startDate?: Date, endDate?: Date) => void;
    disabled?: boolean;
    selectByMonth?: boolean;
};
